import { createAction, props } from "@ngrx/store";

export const toggleMenuMobile = createAction("[LAYOUT] Toggle Menu Mobile");

export const setSubMenu = createAction(
    "[UI] Set SubMenu",
    props<{ submenu: boolean }>()
);

export const setUrl = createAction(
    "[UI] Set Url",
    props<{ urlActive1: string,  urlActive2: string  }>()
);


export const setLoading = createAction(
    "[UI] Set Loading",
    props<{ loading: boolean }>()
);

export const setColorProduct = createAction(
    "[UI] Set Color Product",
    props<{ setcolor: string }>()
);
